import React, {Component} from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
} from 'recharts';
import {getNumericValue} from '../../../common/util/fieldsValidation';

class UsageChart extends Component {
  constructor(props) {
    super(props);
    this.renderCustomizedLabel = this.renderCustomizedLabel.bind(this);
  }

  getContentValue(payload) {
    const {percentage, value} = payload;

    if (!percentage) {
      return `${getNumericValue(value)}`;
    }

    return `${Math.round(percentage)}% (${getNumericValue(value)})`;
  }

  renderCustomizedLabel(props) {
    const {index, x, y, width} = props;
    const element = this.props.data[index];
    const radius = 6;

    return (
      <g>
        <text
          x={x + width / 2}
          y={y - radius}
          fill='black'
          textAnchor='middle'
          dominantBaseline='middle'
        >
          {this.getContentValue(element)}
        </text>
      </g>
    );
  }

  render() {
    const heights = {'small': 250, 'medium': 400};
    const {size, data, index, title, color} = this.props;
    const barColor = color || '#4A90E2';
    const toyotaRed = '#EB0A1E';

    return (
      <div className='usage-chart'>
        <h2>{title}</h2>
        <ResponsiveContainer width='100%' height={heights[size]} key={index}>
          <BarChart
            data={data}
            margin={{'top': 15, 'right': 10, 'left': 10, 'bottom': 5}}
          >
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis dataKey='label' />
            <YAxis />

            <Bar dataKey='value' fill={toyotaRed}>
              <Cell key='cell-0' fill={barColor} />
              <LabelList content={this.renderCustomizedLabel} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default UsageChart;
